import { uninitState, failedState, successState, loadingState } from "@grandvisionhq/state";
import { SHIPPING_METHODS_FAILED, SHIPPING_METHODS_SUCCESS, SHIPPING_METHODS_LOAD } from "./actions.js";
const initialState = uninitState();
function shippingMethodsReducer(state = initialState, action) {
  switch (action.type) {
    case SHIPPING_METHODS_LOAD:
      return loadingState();
    case SHIPPING_METHODS_SUCCESS:
      return successState(action.payload.result);
    case SHIPPING_METHODS_FAILED:
      return failedState(action.error);
    default:
      return state;
  }
}
export {
  shippingMethodsReducer as default,
  initialState
};
//# sourceMappingURL=reducer.js.map
